export default __webpack_public_path__ + "static/preventive-icon.fe822cc5d8666dc3caddd53d00febf2c.svg";